module.exports = __webpack_public_path__ + "static/troy-tyler.c7ebbe75.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/people/troy-tyler.jpg
// module id = 1325
// module chunks = 168707334958949